
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/batch",
      function () {
        return require("private-next-pages/destinations/batch.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/batch"])
      });
    }
  